export class DepartmentRequest{
    deptId:number;
}